function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Controller as t } from "stimulus";
var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);
  var _super = _createSuper(e);
  function e() {
    _classCallCheck(this, e);
    return _super.apply(this, arguments);
  }
  _createClass(e, [{
    key: "initialize",
    value: function initialize() {
      this.placeChanged = this.placeChanged.bind(this);
    }
  }, {
    key: "connect",
    value: function connect() {
      "undefined" != typeof google && this.initAutocomplete();
    }
  }, {
    key: "initAutocomplete",
    value: function initAutocomplete() {
      this.autocomplete = new google.maps.places.Autocomplete(this.addressTarget, this.autocompleteOptions), this.autocomplete.addListener("place_changed", this.placeChanged);
    }
  }, {
    key: "placeChanged",
    value: function placeChanged() {
      this.place = this.autocomplete.getPlace();
      var t = this.place.address_components;
      if (void 0 !== t) {
        var _e = this.formatAddressComponents(t);
        this.setAddressComponents(_e);
      }
      void 0 !== this.place.geometry && this.setGeometry(this.place.geometry);
    }
  }, {
    key: "setAddressComponents",
    value: function setAddressComponents(t) {
      this.hasStreetNumberTarget && (this.streetNumberTarget.value = t.street_number || ""), this.hasRouteTarget && (this.routeTarget.value = t.route || ""), this.hasCityTarget && (this.cityTarget.value = t.locality || ""), this.hasCountyTarget && (this.countyTarget.value = t.administrative_area_level_2 || ""), this.hasStateTarget && (this.stateTarget.value = t.administrative_area_level_1 || ""), this.hasCountryTarget && (this.countryTarget.value = t.country || ""), this.hasPostalCodeTarget && (this.postalCodeTarget.value = t.postal_code || "");
    }
  }, {
    key: "setGeometry",
    value: function setGeometry(t) {
      this.hasLongitudeTarget && (this.longitudeTarget.value = t.location.lng().toString()), this.hasLatitudeTarget && (this.latitudeTarget.value = t.location.lat().toString());
    }
  }, {
    key: "autocompleteOptions",
    get: function get() {
      return {
        fields: ["address_components", "geometry"],
        componentRestrictions: {
          country: this.countryValue
        }
      };
    }
  }, {
    key: "preventSubmit",
    value: function preventSubmit(t) {
      "Enter" === t.code && t.preventDefault();
    }
  }, {
    key: "formatAddressComponents",
    value: function formatAddressComponents(t) {
      var _e2 = {};
      return t.forEach(function (t) {
        var s = t.types[0];
        _e2[s] = t.long_name;
      }), _e2;
    }
  }]);
  return e;
}(t);
e.targets = ["address", "city", "streetNumber", "route", "postalCode", "country", "county", "state", "longitude", "latitude"], e.values = {
  country: Array
};
export default e;